import {BannerPosition} from '@/lib/constants';
import {ApolloError} from '@apollo/client';
import {BannerItems} from '__generated__/__types__';
import {useSliderBannersQuery, useHomepageFloatBannerQuery} from '@/framework/gql/banners.graphql';

export function useSliderBanners({position}: {position: BannerPosition}): {
    data?: BannerItems;
    isLoading: boolean;
    error?: ApolloError;
} {
    const {
        data,
        loading: isLoading,
        error,
    } = useSliderBannersQuery({
        variables: {
            location: position,
        },
    });

    return {
        data: data?.sliderBanners as BannerItems,
        isLoading,
        error,
    };
}

export function useFloatBanner() {
    const {data, loading: isLoading, error} = useHomepageFloatBannerQuery();

    return {
        data: data?.homepageFloatBanner,
        isLoading: isLoading,
        error,
    };
}
